import { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import ModalWaiting from "../Components/ModalWaiting";

function Reconfirm() {
  const [waitingShow, setWaitingShow] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  const [displayPayment, setDisplayPayment] = useState('');
  const [isInvalidated, setIsInvalidated] = useState(false);
  const [isError, setIsError] = useState(false);

  const [reqData, setReqData] = useState({ userID: "", userName: "", params: "", uuid: "", editUrl: "" });

  const GAS_URL = "https://script.google.com/macros/s/AKfycbxV78M9f2XuypgAEfJ3An-chZD1b_FmDONcUuuP9gCCMdY8hwCrGBatowwBVEXxIevS6A/exec";

  useEffect(() => {
    document.title = "最終確認 - 思い出スライド工房";

    const ua = navigator.userAgent;
    const isTouchDevice = /iPhone|iPad|iPod|Android/i.test(ua) || (ua.includes("Mac") && "ontouchend" in document);
    setIsMobile(isTouchDevice);

    const queries = new URLSearchParams(window.location.search);
    const qUserID = queries.get('userID') || "";
    const qUserName = queries.get('userName') || "";
    const qParams = queries.get('params') || "re_confirm";
    const dParam = queries.get('d') || "";

    if (!qUserID || !qUserName) {
      setIsError(true);
      return;
    }

    let parsedData = {};
    if (dParam) {
      try {
        const base64 = dParam.replace(/-/g, '+').replace(/_/g, '/');
        const decoded = decodeURIComponent(escape(window.atob(base64)));
        parsedData = JSON.parse(decoded);
      } catch (e) {
        console.error("Decode error", e);
      }
    }

    setReqData({
      userID: qUserID,
      userName: qUserName,
      params: qParams,
      ...parsedData
    });

    if (parsedData.payment) {
      setDisplayPayment(String(parsedData.payment).replace('?', '円'));
    }

    if (parsedData.status) {
      const currentStatus = String(parsedData.status);
      const statusCode = parseInt(currentStatus.substring(0, 2), 10);
      if (statusCode >= 3) {
        setIsInvalidated(true);
      }
    }
  }, []);

  const handleApply = async () => {
    setWaitingShow(true);
    try {
      const payload = {
        action: "handleFinalApply", 
        ...reqData,
        params: reqData.params + "_final_apply"
      };

      const res = await fetch(GAS_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify(payload)
      });
      const result = await res.json();
      
      if (result.error) throw new Error(result.error);
      setIsFinished(true);
    } catch (err) {
      alert("エラー: " + err.message);
    } finally {
      setWaitingShow(false);
    }
  };

  const handleCancelExecute = async () => {
    setShowCancelModal(false);
    setWaitingShow(true);
    try {
      const payload = {
        action: "handleCancelRequest", 
        ...reqData,
        params: reqData.params + "_cancel_execute"
      };

      const res = await fetch(GAS_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain" },
        body: JSON.stringify(payload)
      });
      const result = await res.json();

      if (result.error) throw new Error(result.error);
      setIsFinished(true);
    } catch (err) {
      alert("エラー: " + err.message);
    } finally {
      setWaitingShow(false);
    }
  };

  const handleEdit = () => {
    const encUserID = encodeURIComponent(reqData.userID);
    const encUserName = encodeURIComponent(reqData.userName);
    const encParams = encodeURIComponent(reqData.params);
    const encEditUrl = encodeURIComponent(reqData.editUrl || "");

    const editGatekeeperUrl = 
      "https://learning.smarteasypos.net/editgatekeeper" + 
      "?userID=" + encUserID + 
      "&userName=" + encUserName + 
      "&params=" + encParams + 
      "&editUrl=" + encEditUrl;
    
    window.location.href = editGatekeeperUrl;
  };

  if (isError) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#666', marginTop: '50px' }}>
        URLパラメーターが正しくありません。<br />
        公式LINEのリンクから再度アクセスしてください。
      </div>
    );
  }

  if (isFinished) {
    return (
      <div style={{ textAlign: "center", padding: "80px 20px", fontFamily: "sans-serif" }}>
        <h3 style={{ color: "#333", marginBottom: "16px" }}>手続きが完了しました</h3>
        <p style={{ color: "#666", lineHeight: "1.6" }}>
          お手数ですが、画面右上の「×」ボタン<br />
          または「完了」を押して画面を閉じてください。
        </p>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "15px" }}>
      <style jsx>{`
        .maincard { max-width: 500px; width: 100%; border: none; }
        .card-title-custom { font-size: 1.25rem; font-weight: bold; color: #1a73e8; text-align: center; padding: 10px 0; }
        .w-80 { width: 80%; }
        .info-box { background-color: #f8f9fa; border-radius: 8px; padding: 15px; margin-bottom: 20px; border: 1px solid #e9ecef; }
        .info-label { font-size: 0.85rem; color: #6c757d; margin-bottom: 2px; }
        .info-value { font-size: 1.2rem; font-weight: bold; color: #212529; margin-bottom: 10px; }
        .deposit-value { font-size: 1rem; font-weight: bold; color: #d93025; }
        .btn-cancel-link { color: #d93025; text-decoration: none; font-size: 0.9rem; }
      `}</style>

      <Card className="maincard shadow mt-4">
        <Card.Body>
          <Card.Title className="card-title-custom mb-3">お申し込みの最終確認</Card.Title>
          
          {isInvalidated ? (
            <Alert variant="secondary" className="text-center py-4 shadow-sm border-0 bg-light">
              <h5 className="fw-bold mb-3 text-secondary">このリンクは無効です</h5>
              <p className="mb-0 small text-muted">
                お手続きが次のステップへ進んでいるか、<br />
                キャンセル処理が完了しているため、<br />
                この確認画面は利用できません。<br />
                <br />
                現在の状況については、<br />
                LINEのトーク画面よりご確認ください。
              </p>
            </Alert>
          ) : (
            <>
              <div className="text-center mb-3 small">
                {reqData.userName} 様、内容をご確認ください。<br/>
                よろしければ「了解」ボタンで確定してください。
              </div>

              <div className="info-box shadow-sm">
                <div className="info-label">見積もり予測</div>
                <div className="info-value text-primary">{displayPayment}</div>
                
                <div className="info-label">着手金（お振り込み頂く金額）</div>
                <div className="deposit-value">1,000円</div>
                <div className="text-muted" style={{fontSize: '0.7rem'}}>※残金は納品前にお支払いいただきます。</div>
              </div>

              <div className="d-flex flex-column align-items-center gap-3">
                {!isMobile ? (
                  <Alert variant="warning" className="w-100 text-start" style={{ fontSize: '0.85rem' }}>
                    代わりに了解して、そのまま進む方は、ラインのトーク画面に届いている見積もり確認ボタンをクリックして出現する画面で了解をクリックしてください。<br />
                    これ以降、管理一元のため、LINEでのやり取りになります。<br />
                    よろしくお願いします。
                  </Alert>
                ) : (
                  <Button variant="primary" className="w-80 py-3 fw-bold shadow" onClick={handleApply}>
                    了解（申し込む）
                  </Button>
                )}

                <Button variant="outline-secondary" className="w-80" onClick={handleEdit}>
                  内容を修正する
                </Button>

                <Button variant="link" className="btn-cancel-link mt-2" onClick={() => setShowCancelModal(true)}>
                  お申し込みをキャンセルする
                </Button>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="h6 fw-bold">キャンセルの確認</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          お申し込みをキャンセルしてもよろしいですか？<br/>
          <small className="text-muted">※一度キャンセルすると元に戻せません。</small>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pb-4">
          <Button variant="danger" className="px-4 fw-bold" onClick={handleCancelExecute}>
            はい、キャンセルします
          </Button>
          <Button variant="secondary" className="px-4" onClick={() => setShowCancelModal(false)}>
            いいえ
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalWaiting show={waitingShow} />
    </div>
  );
}

export default Reconfirm;
